import * as Yup from 'yup';
export type ArticleCategoryModel = {
    id: number;
    name: string;
    slug: string;
    icon: string;
    keyWords: string;
    description: string;
    parentId: number;
    catTree: string;
    genre: string;
    inActive: boolean;
    sortOrder: number;
    isHidden: boolean;
    sortOrderSub: number;
    isHiddenSub: boolean;
    sortOrderFooter: number;
    isHiddenFooter: boolean;
}

export const dfArticleCategoryModel: ArticleCategoryModel = {
    id: 0,
    name: '',
    catTree: '',
    description: '',
    genre: '',
    icon: '',
    inActive: false,
    isHidden: true,
    isHiddenFooter: true,
    isHiddenSub: true,
    keyWords: '',
    parentId: 0,
    slug: '',
    sortOrder: 0,
    sortOrderFooter: 0,
    sortOrderSub: 0,
}

export const validArticleCategorySchema = () => Yup.object().shape({
    name: Yup.string().required('Vui lòng nhập Tên chuyên mục bài viết.'),
    slug: Yup.string().required('Vui lòng nhập Link chuyên mục bài viết.'),
});